import * as en from './en.json';
import * as fr from './fr.json';

const translations = {
	en: {translations: en.default},
	fr: {translations: fr.default}
};

export default translations;